import { MenuItem } from "../assets/interfaces/commom_interfaces";
import { OutletInterface, PageInfo } from "../assets/interfaces/FX_POS_Interfaces";

export const CLIENT_ID = "CLIENT_ID";
export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const OUTLET_LIST = "OUTLET_LIST"
export const RESET_STATE = "RESET_STATE"
export const OUTLET_ID = "OUTLET_ID"
export const ME_DETAILS = "ME_DETAILS"
export const PAGE_INFO = "PAGE_INFO"
export const MENU_LIST = "MENU_LIST"
export const APP_INTEGRATIONS = "APP_INTEGRATIONS"
export const QUICK_ACTION = "QUICK_ACTION"

export const resetState = () => ({
  type: "RESET_STATE",
});

export const accessToken = (access_token: string) => ({
  type: ACCESS_TOKEN,
  payload: access_token,
});
export const storeClientId = (payload: string) => ({
  type: CLIENT_ID,
  payload: payload,
})
export const storeMeDetails = (payload: string) => ({
  type: ME_DETAILS,
  payload: payload,
})
export const storeSelectedOutlet = (payload: OutletInterface[]) => ({
  type: OUTLET_ID,
  payload: payload,
})
export const storeSelectedAction = (payload: { label: string; value: string }[]) => ({
  type: QUICK_ACTION,
  payload: payload,
})
export const storeOutlets = (outlets: OutletInterface[]) => ({
  type: OUTLET_LIST,
  payload: outlets,
})
export const storePageInfo = (page: PageInfo) => ({
  type: PAGE_INFO,
  payload: page,
})
export const storeMenuList = (page: MenuItem[]) => ({
  type: MENU_LIST,
  payload: page,
})
export const storeAppIntegrations = (page: any[]) => ({
  type: APP_INTEGRATIONS,
  payload: page,
})
